module.exports = __webpack_public_path__ + "static/media/lottery_detail_top@2x.0606bb15.webp";